import {ValueValidator} from "../Validator";
import {ChipInputField} from "../../chipInputField/ChipInputField";
import {OnValidChangeHandler, ValidationComponent} from "./ValidationComponent";
import {RootState} from "../../../../app/store";

interface Props<OBJECT> {
    validator: ValueValidator<string>
    selector: (state: RootState) => string | undefined
    fieldName: keyof OBJECT
    onChange: (value: string) => any
    updateValidationStatus: OnValidChangeHandler<OBJECT>
    label: string
    placeholder?: string
    disabled?: boolean
    required?: boolean
    getMessage: (f: string) => string
}

export const ValidatedChipInputField = <OBJECT, >({
                                                             validator,
                                                             selector,
                                                             fieldName,
                                                             onChange,
                                                             updateValidationStatus,
                                                             label,
                                                             placeholder,
                                                             disabled,
                                                             getMessage,
                                                             required = true
                                                         }: Props<OBJECT>) => {
    return <ValidationComponent<string, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        disabled={disabled}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <ChipInputField
                isRequired={required}
                title={label}
                value={value as string}
                disabled={disabled}
                setValue={onChange as (value: string) => void}
                placeholder={placeholder}
                errorMessage={getMessage(fieldName as string)}
                chipValidator={validator}
            />
        }
    />
}; 
